import { useTheme } from 'styled-components';
import { Driver as DriverProps } from '../../../../API/types/Drivers';
import { IconKeys } from '../../../../components/common/Icon/IconKeys';
import Tags from '../../../../components/common/Tags';
import { generateDistance } from '../../../../utils/unitsUtils';
import { generatePreviewFullName } from '../../../Drivers/Modals/helpers';
import S from './AssignDeviceToVehicleStyles';
import useDriverThumbnail from '../../../../theme/useDriverThumbnail';
import { ThemeType } from '../../../../theme/themeType';
import { generateScoreColor, getScoreLabel, hasDisplayableEntityScore } from '../../../../utils/commonUtils';

type Props = {
  driver: DriverProps;
  isChecked: boolean;
  selectDriver: (driver: DriverProps) => void;
};

function Driver({ driver, isChecked, selectDriver }: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const driverThumbnail = useDriverThumbnail();
  const {
    _id: driverId,
    distanceInKmTotal,
    firstName,
    lastName,
    avatarUrl,
    licenseName,
    score,
  } = driver;

  return (
    <S.DriverWrapper
      onClick={() => selectDriver(driver)}
    >
      <input type="radio" name="sort-by" id={driverId} checked={isChecked} disabled />
      <label htmlFor={driverId}>
        {hasDisplayableEntityScore(score, distanceInKmTotal) && (
          <Tags.Status label={getScoreLabel(score)} backgroundColor={generateScoreColor(score)} />
        )}
        {!hasDisplayableEntityScore(score, distanceInKmTotal) && (
          <Tags.Status label="No score" backgroundColor={theme.colors.outline} title="This vehicle didn't have any trips yet." />
        )}
        <span className="checkbox" />
      </label>
      <Tags.ItemOverview
        avatar={avatarUrl || driverThumbnail}
        avatarAlt="driver"
        title={generatePreviewFullName(firstName, lastName)}
        subtitle={licenseName as string}
      />
      <div className="tags-container">
        <Tags.LabeledIcon
          label={generateDistance(distanceInKmTotal, true)}
          icon={IconKeys.DISTANCE}
        />
      </div>
    </S.DriverWrapper>
  );
}

export default Driver;
